export default {
  name: "Separator",
  props: {
    backgroundDirection: String,
  },
};
